import React from "react";
import { Modal } from "reactstrap";
import PaymentCreditCardForm from "./PaymentCreditCardForm";

const PaymentCreditCardModal = ({ program, isOpen, setOpen, toggle }) => {
  const props = { btnLabel: "Make Deposit", program };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Billing</span>
          <h3 className="modal-2col__title">Credit Card Payment</h3>
          <p className="modal-2col__description">
            Enter the deposit amount and complete the secure credit card
            payment flow for the selected program. The balance will be updated
            after the payment processor confirms the transaction.
          </p>
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <PaymentCreditCardForm {...props} />
      </div>
    </Modal>
  );
};

export default PaymentCreditCardModal;
